import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './css/BottomNav.css';

const HIDDEN_PATHS = ['/sign-in', '/sign-up', '/forgot-password', '/reset-password', '/'];

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut, profileData } = useAuth();
  const [showProfile, setShowProfile] = useState(false);

  const path = location.pathname;

  if (path.startsWith('/admin') || HIDDEN_PATHS.includes(path) || !user) {
    return null;
  }

  const isActive = (href) => path === href;

  const handleLogout = async () => {
    setShowProfile(false);
    await signOut();
    navigate('/sign-in');
  };

  const fullName = user?.user_metadata?.full_name || profileData?.fullName || '';
  const email = user?.email || '';
  const avatarUrl = profileData?.profileImage || null;
  const initials = fullName ? fullName.charAt(0).toUpperCase() : email.charAt(0).toUpperCase();

  return (
    <>
      <nav className="bottom-nav" role="navigation" aria-label="Main navigation">
        <div className="bottom-nav__tabs">

          {/* Home */}
          <Link
            to="/welcome"
            className={`bottom-nav__tab${isActive('/welcome') ? ' active' : ''}`}
            aria-label="Home"
          >
            <i className="bx bx-home-alt-2"></i>
            <span>Home</span>
            <span className="bottom-nav__dot" aria-hidden="true"></span>
          </Link>

          {/* Wallet */}
          <Link
            to="/wallet"
            className={`bottom-nav__tab${isActive('/wallet') ? ' active' : ''}`}
            aria-label="Wallet"
          >
            <i className="bx bx-wallet"></i>
            <span>Wallet</span>
            <span className="bottom-nav__dot" aria-hidden="true"></span>
          </Link>

          {/* Send — floating action button */}
          <Link
            to="/wallet?action=send"
            className="bottom-nav__tab bottom-nav__tab--send"
            aria-label="Send money"
          >
            <div className="bottom-nav__send-icon">
              <i className="bx bx-send"></i>
            </div>
            <span>Send</span>
          </Link>

          {/* Referral */}
          <Link
            to="/referral"
            className={`bottom-nav__tab${isActive('/referral') ? ' active' : ''}`}
            aria-label="Referral program"
          >
            <i className="bx bx-gift"></i>
            <span>Refer</span>
            <span className="bottom-nav__dot" aria-hidden="true"></span>
          </Link>

          {/* Profile */}
          <button
            className="bottom-nav__tab"
            onClick={() => setShowProfile(true)}
            aria-label="Profile"
          >
            <i className="bx bx-user-circle"></i>
            <span>Profile</span>
          </button>

        </div>
      </nav>

      {/* Profile Sheet */}
      {showProfile && (
        <>
          <div
            className="profile-sheet-overlay"
            onClick={() => setShowProfile(false)}
            aria-hidden="true"
          />
          <div className="profile-sheet" role="dialog" aria-label="Profile">
            <div className="profile-sheet__handle" aria-hidden="true" />

            <div className="profile-sheet__header">
              {avatarUrl ? (
                <img
                  src={avatarUrl}
                  alt={fullName}
                  className="profile-sheet__avatar"
                />
              ) : (
                <div className="profile-sheet__avatar-placeholder" aria-hidden="true">
                  {initials}
                </div>
              )}
              <div>
                <p className="profile-sheet__name">{fullName || 'User'}</p>
                <p className="profile-sheet__email">{email}</p>
              </div>
            </div>

            <div className="profile-sheet__divider" />

            <div className="profile-sheet__menu">
              <Link
                to="/profile"
                className="profile-sheet__menu-item"
                onClick={() => setShowProfile(false)}
              >
                <span className="profile-sheet__menu-icon profile-sheet__menu-icon--profile">
                  <i className="bx bx-user-edit"></i>
                </span>
                Edit Profile
                <i className="bx bx-chevron-right profile-sheet__menu-item-arrow"></i>
              </Link>

              <Link
                to="/profile?section=security"
                className="profile-sheet__menu-item"
                onClick={() => setShowProfile(false)}
              >
                <span className="profile-sheet__menu-icon profile-sheet__menu-icon--security">
                  <i className="bx bx-lock-alt"></i>
                </span>
                Security &amp; Password
                <i className="bx bx-chevron-right profile-sheet__menu-item-arrow"></i>
              </Link>

              <Link
                to="/account-statement"
                className="profile-sheet__menu-item"
                onClick={() => setShowProfile(false)}
              >
                <span className="profile-sheet__menu-icon profile-sheet__menu-icon--history">
                  <i className="bx bx-file-blank"></i>
                </span>
                Account Statement
                <i className="bx bx-chevron-right profile-sheet__menu-item-arrow"></i>
              </Link>

              <Link
                to="/notifications"
                className="profile-sheet__menu-item"
                onClick={() => setShowProfile(false)}
              >
                <span className="profile-sheet__menu-icon profile-sheet__menu-icon--history">
                  <i className="bx bx-bell"></i>
                </span>
                Notifications
                <i className="bx bx-chevron-right profile-sheet__menu-item-arrow"></i>
              </Link>

              <Link
                to="/market-trends"
                className="profile-sheet__menu-item"
                onClick={() => setShowProfile(false)}
              >
                <span className="profile-sheet__menu-icon profile-sheet__menu-icon--history">
                  <i className="bx bx-trending-up"></i>
                </span>
                Market Trends
                <i className="bx bx-chevron-right profile-sheet__menu-item-arrow"></i>
              </Link>
            </div>

            <div className="profile-sheet__divider" />

            <div className="profile-sheet__logout-section">
              <button className="profile-sheet__logout-btn" onClick={handleLogout}>
                <i className="bx bx-log-out"></i>
                Sign Out
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Footer;
